<template>
  <div id="app">
    
    <router-view></router-view>    

  </div>
</template>

<script>
export default {
  name: 'app',
  data () {
    return {
      
    }
  }
}
</script>

<style lang="scss">
  @import "./sass/style.scss";  

  #app{
    height: 100%;
  }

</style>



// WEBPACK FOOTER //
// src/App.vue